import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Validators, AbstractControl, FormControl, FormArray } from '@angular/forms';
import { FormPackage } from '../../models/df-package';
import { ComponentService } from '../../../../../../../services/component.service';

@Component({
	selector: 'df-file-box',
	templateUrl: './file-box.component.html',
	styleUrls: ['./file-box.component.scss']
})
export class FileBoxComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() config: FormGroup;
	@Input() form: FormGroup;
	@Input() componentData: any;
	additionalFields: boolean;
	public settings = [];
	files;

	constructor(private cs: ComponentService, private cd: ChangeDetectorRef) {}

	ngOnInit() {
		this.settings = this.package.settings;
		this.additionalFields = this.settings['additionalFields'];
		this.files = this.config.get(this.package.key) as FormArray;
	}

	addFile(event: MouseEvent): void {
		this.files.push(new FormControl(''));
		this.cd.detectChanges();
		event.preventDefault();
		event.stopImmediatePropagation();
	}

	removeFile(event: MouseEvent, index: number): void {
		var fileName = 'the empty spot';

		if (this.files.value[index] && this.files.value[index] != '') {
			const arr = this.files.value[index].split('/');
			fileName = arr[arr.length - 1];
		}

		if (confirm(`Are sure you want to remove ${fileName} ?`)) {
			this.files.removeAt(index);
			this.cd.detectChanges();
			event.preventDefault();
			event.stopImmediatePropagation();
		}
	}
}
